import React from "react"
import "./downloadPartner.scss"

const DownloadPartner = () => {
  const scrollToForm = () => {
    const hero = document.querySelector(".hero-partner")
    if (hero) hero.scrollIntoView({ behavior: "smooth" })
  }

  return (
    <section className="download-partner">
      <div className="download-partner__container">
        <div className="download-partner__content">
          <h2 className="download-partner__heading">
            Ready to Drive &amp; <span>Earn?</span>
          </h2>
          <p className="download-partner__desc">
            Complete your free cab driver registration, attach your car, and
            start earning. It takes less than 2 minutes.
          </p>
          <button className="download-partner__cta" onClick={scrollToForm}>
            Register Now - It's Free
          </button>
        </div>
      </div>
    </section>
  )
}

export default DownloadPartner
